import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContratoService } from 'src/app/services/contrato/contrato.service';
import { showInfo } from 'src/utils/showInfoMessage';

@Component({
    selector: 'spe-termo-premmiar',
    templateUrl: './termo-premmiar.component.html',
    styleUrls: ['./termo-premmiar.component.scss'],
    standalone: false
})
export class TermoPremmiarComponent {
  @Input() idPublicacao: number = 0;
  aceite: boolean = false;

  constructor(private contratoService: ContratoService, private dialog: MatDialog) {}

  submitForm() {
    if (!this.aceite) {
      showInfo(this.dialog, 'Para continuar é necessário ler e aceitar o termo de fidelidade.');
    } else {
      this.contratoService.aceitar(this.idPublicacao).subscribe({
        next: () => {
          window.location.reload();
        }
      });
    }
  }
}
